import { useEffect, useState } from 'react';
import {
  ApiErrorText,
  // Button,
  ModalComponentWrapper,
} from '@/shared/components';
// import HistoryIcon from '@/shared/assets/history-icon.svg?react';
import { useWithdrawCardForm, type WithdrawCardModalState } from '../model';
import { useTranslation } from 'react-i18next';
import { NUMERIC_CONFIG } from '@/shared/config';
import { useModalStore, useOperationsPreSelectAsset } from '@/shared/lib';
import { useWithdrawCardModals } from '../lib';
import { WithdrawCardForm } from '@/features/withdraw-card';
import { WithdrawModalFooter } from '@/entities/operation';
import type { OperationModalProps } from '@/shared/types';
import type { SavedCard } from '@/entities/card';

export const WithdrawCardModal = ({
  assetCode,
  onBack,
  title,
  onEditSavedCard,
  // onHistoryClick,
}: OperationModalProps & {
  onEditSavedCard: (savedCard: SavedCard) => void;
}) => {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const { t } = useTranslation();
  const { setState, setMultipleState, setCloseConfirmationRequired } =
    useModalStore();
  const { openConfirmationModal } = useWithdrawCardModals();

  useEffect(() => {
    setCloseConfirmationRequired(isFormDirty);
  }, [isFormDirty, setCloseConfirmationRequired]);

  const {
    form,
    watchedValues,
    savedCards,
    assetOptions,
    selectedCurrency,
    hasWithdrawFee,
    isFromDataLoading,
    isFormDataError,
    formDataError,
    commissionData,
    templateId,
    setTemplateId,
    handleFormSubmit,
    error,
    handleMaxClick,
    isLoading,
    accountNumber,
    cardIconConfig,
    totalAmount,
  } = useWithdrawCardForm({
    onValidateSuccess: userCardId => {
      setMultipleState<WithdrawCardModalState>({
        selectedCurrency,
        withdrawCardFormData: watchedValues,
        accountNumber,
        commissionData,
        fee: commissionData?.feeAmount || 0,
        totalAmount,
        userCardId,
        isNeedToSaveTemplate: !templateId,
      });
      openConfirmationModal();
    },
  });

  useOperationsPreSelectAsset({
    assetCode,
    options: assetOptions,
    setValue: code => form.setValue('currencyCode', code),
  });

  // const onHistoryClickHandler = () => {
  //   setState('withdrawCardFormData', watchedValues);

  //   onHistoryClick(
  //     selectedCurrency?.code ? { assetCode: selectedCurrency?.code } : undefined
  //   );
  // };

  const handleEditSavedCard = (savedCard: SavedCard) => {
    setState('withdrawCardFormData', watchedValues);
    onEditSavedCard(savedCard);
  };

  return (
    <ModalComponentWrapper
      title={title}
      onBack={onBack}
      // actions={
      //   <Button
      //     variant="secondary"
      //     onClick={onHistoryClickHandler}
      //     className="flex items-center justify-center size-[4.2rem] bg-muted hover:bg-muted/80 bg-transparent-bg transition-colors text-foreground shadow-none self-start rounded-full border border-border mr-[0.8rem]"
      //     aria-label="history">
      //     <HistoryIcon className="size-[2.4rem] text-foreground" />
      //   </Button>
      // }
      footerClassName="sm:px-0 px-0 before:invisible"
      footer={
        <WithdrawModalFooter
          precision={NUMERIC_CONFIG.precision.default}
          amount={totalAmount}
          assetCode={watchedValues.currencyCode}
          withdrawFee={commissionData?.feeAmount || 0}
          includeFee={hasWithdrawFee && Boolean(watchedValues.includeFee)}
          disabled={isFromDataLoading || isLoading}
          isLoading={isLoading}
          onSubmit={() => form.handleSubmit(handleFormSubmit)()}
          submitLabel={t('withdrawMethods.crypto.submitButton')}
        />
      }>
      <WithdrawCardForm
        form={form}
        watchedValues={watchedValues}
        assetOptions={assetOptions}
        selectedAsset={selectedCurrency}
        hasWithdrawFee={hasWithdrawFee}
        setTemplateId={setTemplateId}
        isLoading={isFromDataLoading}
        isError={isFormDataError && !isLoading}
        error={formDataError}
        onMaxClick={handleMaxClick}
        onFormDirtyChange={setIsFormDirty}
        savedCards={savedCards}
        onEditSavedCard={handleEditSavedCard}
        commissionData={commissionData}
        cardIconConfig={cardIconConfig}
      />
      {!isLoading && error && <ApiErrorText error={error} />}
    </ModalComponentWrapper>
  );
};
